import { createApi } from '@reduxjs/toolkit/query/react';
import { saveAs } from 'file-saver';
import { createBaseQuery } from 'helpers/api';
import { stringDate } from 'helpers/date';

export const checkTypePricingApi = createApi({
  reducerPath: 'checkTypePricingApi',
  tagTypes: ['CheckTypePricing'],
  baseQuery: createBaseQuery('check_type_pricing', { timeout: 0 }),
  endpoints: builder => ({
    getCheckTypePricing: builder.query({
      query: () => ({ url: '/' }),
      transformResponse: ({ result }) => result ?? [],
      providesTags: ['CheckTypePricing'],
    }),
    getGlobalRates: builder.query({
      query: () => ({ url: '/global_rates' }),
      transformResponse: ({ result }) => result ?? {},
      providesTags: ['CheckTypePricing'],
    }),
    updateGlobalRates: builder.mutation({
      query: body => ({
        url: '/global_rates',
        method: 'PUT',
        body,
      }),
      transformResponse: ({ result }) => result ?? {},
      invalidatesTags: ['CheckTypePricing'],
    }),
    updateCheckTypePricing: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: 'PUT',
        body,
      }),
      transformResponse: ({ result }) => result ?? {},
      invalidatesTags: ['CheckTypePricing'],
    }),
    getCompanyChecksReport: builder.query({
      queryFn: async (params = {}, api, extraOptions, baseQuery) => {
        const { data: file } = await baseQuery({
          url: '/company_checks_report',
          params,
          responseHandler: async response => {
            const blob = await response.blob();
            return blob;
          },
          cache: 'no-cache',
        });
        saveAs(file, `${stringDate()}_company_checks_pricing.csv`);
        return { data: null };
      },
    }),
  }),
});

export const {
  useGetCheckTypePricingQuery,
  useGetGlobalRatesQuery,
  useUpdateGlobalRatesMutation,
  useUpdateCheckTypePricingMutation,
  useLazyGetCompanyChecksReportQuery,
} = checkTypePricingApi;
